import useStore from '../../../../store';
import { LandlordBooking, TenantBooking } from '../../../../types/bookings';
import BookingInformationLandlordButton from './BookingLandlordInformationButton';
import BookingInformationTenantButton from './BookingTenantInformationButton';

interface IBookingInformationProps {
  booking: LandlordBooking | TenantBooking;
  onAcceptOpen: () => void;
  onRejectOpen: () => void;
  onCounterOfferOpen: () => void;
  onTenantCounterOfferOpen: () => void;
}

const BookingInformationButton = ({
  booking,
  onAcceptOpen,
  onRejectOpen,
  onCounterOfferOpen,
  onTenantCounterOfferOpen,
}: IBookingInformationProps) => {
  const { user } = useStore(state => ({
    user: state.user,
  }));
  return (
    <>
      {user?.type === 'landlord' && (
        <BookingInformationLandlordButton
          booking={booking as LandlordBooking}
          onAcceptOpen={onAcceptOpen}
          onRejectOpen={onRejectOpen}
          onCounterOfferOpen={onCounterOfferOpen}
        />
      )}
      {user?.type === 'tenant' && (
        <BookingInformationTenantButton
          booking={booking as TenantBooking}
          onCounterOfferOpen={onTenantCounterOfferOpen}
        />
      )}
    </>
  );
};

export default BookingInformationButton;
